import React, { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom"; // ✅ Link 추가
import "../../assets/css/container/board/WriteRep.css"; // WriteNew 스타일 재사용
import CategoryPicker from "../../component/CategoryPicker";
import axios from "../../util/axiosConfig";
import TiptapEditor from "../../component/TiptapEditor";

type LocationState = {
	parentId: number;
	parentTitle: string;
	answerType: "positive" | "negative";
};

function WriteRep() {
	const navigate = useNavigate();
	const location = useLocation();
	const { parentId, parentTitle, answerType } = location.state as LocationState;

	const [title, setTitle] = useState("");
	const [category, setCategory] = useState("");
	const [content, setContent] = useState(""); // HTML 저장

	// 답변 유형 안내 문구
	const answerText: Record<typeof answerType, string> = {
		positive: "긍정 근거",
		negative: "부정 근거",
	};

	// ✅ 저장
	const handleSave = async () => {
		if (!title || !category || !content.trim()) {
			alert("제목, 카테고리, 내용을 모두 입력해 주세요.");
			return;
		}

		try {
			await axios.post("/api/board/reply/save", {
				parentId,
				answerType,
				title,
				category,
				content,
			});

			alert("근거 글이 작성되었습니다!");
			navigate(`/viewPost/${parentId}`); // 다시 부모글로 이동
		} catch (err) {
			console.error("근거 글 저장 실패:", err);
			alert("저장 실패. 다시 시도해 주세요.");
		}
	};

	return (
		<div className="WriteRep">
			<p className="ReplyNotice">
				이 글은{" "}
				<Link to={`/viewPost/${parentId}`} className="ParentButton">
					<strong>{parentId}번: {parentTitle}</strong>
				</Link>{" "}
				글의 <b>{answerText[answerType]}</b>으로 작성 중입니다.
			</p>

			{/* 제목 입력 */}
			<textarea
				placeholder="제목을 입력해 주세요."
				className="SetTitle"
				value={title}
				onChange={(e) => setTitle(e.target.value)}
			/>

			{/* 카테고리 선택 */}
			<CategoryPicker value={category} onChange={setCategory} />

			{/* ✅ 공통 TiptapEditor */}
			<TiptapEditor content={content} onChange={setContent} />

			<button className="WriteRepSaveBtn" onClick={handleSave}>저장</button>

		</div>
	);
}

export default WriteRep;
